var _module_exports ="<div ui-view=\"sidebar\"></div>\n\n<div class=\"main-content smaller nopadding\">\n    <div ui-view=\"details\"></div>\n</div>\n";;
var path = '/app/Main/systemOwnerReview/confirmSystemOwnership/ConfirmSystemOwnership.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;